




































































import IconChaperone from '@/assets/icons/chaperone.svg';
import { Component, Vue, Prop } from 'vue-property-decorator';
import NewTranslation from '@/components/i18n/NewTranslation.vue';
import { downloadCodeUrl, formatDownloadCode } from '@/app/utils/formatDownloadCode';
import WalletButton from '@/components/qr/WalletButton.vue';
import Logo from '@/components/Logo.vue';
import moment from 'moment';
import { State } from 'vuex-class';

@Component({
  components: { Logo, NewTranslation, IconChaperone, WalletButton },
})
export default class TaxcardSummary extends Vue {
  @Prop(Object)
  taxcard!: any;

  public get isCityTour() {
    return this.taxcard.subGuestType === 'cityTour';
  }

  public get downloadCodeDisplay() {
    return formatDownloadCode(this.taxcard.downloadCode);
  }

  public get downloadCodeHref() {
    return downloadCodeUrl(this.taxcard.downloadCode);
  }

  @Prop({type: Number, required: false})
  communeId!: number;

  @Prop(String)
  qrCode!: string;

  @Prop({ type: Boolean, default: false })
  digitalOutputBlocked!: boolean;

  @State
  lang!: string;

  mounted() {}

  public get isSingleDay() {
    return this.stayBegin.isSame(this.stayEnd);
  }

  public get stayBegin() {
    return moment(this.taxcard.stayBegin);
  }

  public get stayEnd() {
    return moment(this.taxcard.stayEnd);
  }

  public get birthday() {
    if (this.taxcard.personBirthday) {
      return moment.utc(this.taxcard.personBirthday).local().format('DD.MM.YYYY');
    }
    return '';
  }

  public get priceOptionLabel() {
    return this.taxcard.optionLabelKey;
  }

  public get priceOptions() {
    if (!this.taxcard.option) {
      return [];
    }
    return Object.values(this.taxcard.option).map((option: any) => {
      const values = Array.isArray(option.value) ? option.value.map((val: any) => String(val)) : [String(option.value)];

      return {
        label: option[`label_${this.lang}`] || option[`label_en`],
        value: values.join(', '),
      };
    });
  }

  public get optionIcon(): string {
    if (this.taxcard.isDisabled) {
      return 'wheelchair';
    } else if (this.taxcard.isResident) {
      return 'address-card';
    }
    return '';
  }
}
